import React from "react";
import BASE_URL from "Utilities/BASE_URL";
import { leadPlusLabel } from "Utilities/courseInstructors";

const SERVER_URL = BASE_URL.replace(/\/api$/, "");
const imgUrl = (p) => (!p ? null : p.startsWith("http") ? p : `${SERVER_URL}/${p}`);

// Overlapping avatar stack + "Lead +N" caption. Shared by course cards so
// multiple instructors read at a glance without crowding the card.
const InstructorAvatars = ({
  instructors = [],
  size = 24,
  max = 3,
  textClass = "text-sm text-white/50",
}) => {
  const list = (instructors || []).filter(Boolean);
  if (list.length === 0) return null;

  const shown = list.slice(0, max);
  const initialClass = size <= 20 ? "text-[9px]" : "text-[10px]";
  const dim = { width: size, height: size };

  return (
    <div className="flex items-center gap-2 mt-1.5">
      <div className="flex">
        {shown.map((inst, i) => {
          const img = imgUrl(inst?.profileImage);
          const overlap = i ? { marginInlineStart: -8 } : null;
          return img ? (
            <img
              key={inst._id || i}
              src={img}
              alt={inst?.name}
              style={{ ...dim, ...overlap }}
              className="rounded-full object-cover ring-1 ring-white/20 border border-black/40"
              loading="lazy"
            />
          ) : (
            <div
              key={inst._id || i}
              style={{ ...dim, ...overlap }}
              className={`rounded-full bg-primary/30 flex items-center justify-center ${initialClass} font-bold text-white ring-1 ring-white/20 border border-black/40`}
            >
              {inst?.name?.charAt(0)}
            </div>
          );
        })}
      </div>
      <span className={textClass}>{leadPlusLabel(list)}</span>
    </div>
  );
};

export default InstructorAvatars;
